import { useState } from "react";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WaitlistForm({ testid = "waitlist", centered = true }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      const res = await fetch(`${API}/leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, source: "os-waitlist" }),
      });
      if (!res.ok) throw new Error("Request failed");
      setStatus("success");
    } catch {
      setStatus("error");
    }
  };

  if (status === "success") {
    return (
      <p
        data-testid={`${testid}-success`}
        className={`inline-block border border-amber/50 bg-amber-soft px-8 py-5 font-serif text-xl font-light text-ink ${centered ? "mx-auto mt-10" : ""}`}
      >
        You&apos;re on the list. We&apos;ll keep you posted.
      </p>
    );
  }

  return (
    <form
      data-testid={`${testid}-form`}
      onSubmit={submit}
      className={
        centered
          ? "mx-auto mt-10 flex max-w-md flex-col gap-3 sm:flex-row"
          : "flex w-full flex-col gap-3 sm:flex-row"
      }
    >
      <input
        type="email"
        required
        data-testid={`${testid}-email`}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        aria-label="Email address"
        className="w-full flex-1 border border-line bg-white px-4 py-3 text-sm text-ink placeholder:text-faint/70 transition-colors duration-300 focus:border-amber focus:outline-none"
      />
      <button
        type="submit"
        data-testid={`${testid}-submit`}
        disabled={status === "sending"}
        className="group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-full bg-ink px-7 py-3.5 text-sm font-semibold tracking-wide text-paper transition-colors duration-300 hover:bg-amber disabled:opacity-60"
      >
        {status === "sending" ? "Sending…" : "Keep Me Posted"}
        <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5" />
      </button>
      {status === "error" && (
        <p data-testid={`${testid}-error`} className="border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          Something went wrong. Please try again, or email kpstrategyteam@gmail.com directly.
        </p>
      )}
    </form>
  );
}
